// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiosPagados_container__W8fZx {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.PremiosPagados_container__W8fZx .PremiosPagados_header__HRsGY {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.PremiosPagados_container__W8fZx .PremiosPagados_header__HRsGY .PremiosPagados_titleContainer__TZioN {
  animation: PremiosPagados_toright__3KOEt 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.PremiosPagados_container__W8fZx .PremiosPagados_header__HRsGY .PremiosPagados_titleContainer__TZioN h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.PremiosPagados_container__W8fZx .PremiosPagados_header__HRsGY .PremiosPagados_arrow__kFDfo {
  transition: 0.5s;
  border-radius: 50%;
}

.PremiosPagados_container__W8fZx .PremiosPagados_header__HRsGY .PremiosPagados_arrow__kFDfo:hover {
  cursor: pointer;
  transition: 0.5s;
  scale: 1.1;
  background-color: rgba(34, 34, 34, 0.1);
}

.PremiosPagados_container__W8fZx .PremiosPagados_loader__xy65r {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.PremiosPagados_container__W8fZx .PremiosPagados_data__tG4Zy {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
}

/*---Información---*/
.PremiosPagados_container__W8fZx .PremiosPagados_data__tG4Zy .PremiosPagados_tableContainer__sNFpH {
  animation: PremiosPagados_toleft__\\+zerq 0.3s;
  max-height: 80vh;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.PremiosPagados_container__W8fZx .PremiosPagados_data__tG4Zy .PremiosPagados_tableContainer__sNFpH .PremiosPagados_tableHeader__chNEv {
  font-size: 0.9rem;
  font-weight: 500;
}

.PremiosPagados_container__W8fZx .PremiosPagados_filters__2mWNW {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.PremiosPagados_container__W8fZx .PremiosPagados_filters__2mWNW .PremiosPagados_item__Z7zdx {
  animation: PremiosPagados_init__adpCK 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
}

.PremiosPagados_container__W8fZx .PremiosPagados_filters__2mWNW .PremiosPagados_init1__8j0Uo {
  animation: PremiosPagados_init__adpCK 0.5s 0.2s both;
}
.PremiosPagados_container__W8fZx .PremiosPagados_filters__2mWNW .PremiosPagados_init2__Hi5Lg {
  animation: PremiosPagados_init__adpCK 0.5s 0.4s both;
}
.PremiosPagados_container__W8fZx .PremiosPagados_filters__2mWNW .PremiosPagados_init3__nhitH {
  animation: PremiosPagados_init__adpCK 0.5s 0.6s both;
}

.PremiosPagados_container__W8fZx .PremiosPagados_options__0Y2Jr {
  animation: PremiosPagados_toright__3KOEt 0.5s 1s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.PremiosPagados_container__W8fZx .PremiosPagados_options__0Y2Jr p {
  margin: 0 0 0 10px;
  text-transform: capitalize;
  font-weight: 300;
}

@keyframes PremiosPagados_init__adpCK {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes PremiosPagados_toright__3KOEt {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes PremiosPagados_toleft__\\+zerq {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  .PremiosPagados_container__W8fZx .PremiosPagados_filters__2mWNW {
    display: none;
  }

  .PremiosPagados_container__W8fZx .PremiosPagados_options__0Y2Jr {
    display: none;
  }

  .PremiosPagados_container__W8fZx .PremiosPagados_header__HRsGY {
    display: none;
  }

  .PremiosPagados_container__W8fZx .PremiosPagados_data__tG4Zy .PremiosPagados_tableContainer__sNFpH {
    box-shadow: none;
  }

  .PremiosPagados_container__W8fZx .PremiosPagados_data__tG4Zy .PremiosPagados_tableContainer__sNFpH .PremiosPagados_tableHeader__chNEv {
    color: black !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/PremiosPagados/PremiosPagados.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6CAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,6CAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,+CAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oDAA8B;AAChC;AACA;EACE,oDAA8B;AAChC;AACA;EACE,oDAA8B;AAChC;;AAEA;EACE,qDAA+B;EAC/B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .header .arrow {\n  transition: 0.5s;\n  border-radius: 50%;\n}\n\n.container .header .arrow:hover {\n  cursor: pointer;\n  transition: 0.5s;\n  scale: 1.1;\n  background-color: rgba(34, 34, 34, 0.1);\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: toleft 0.3s;\n  max-height: 80vh;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableHeader {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filters .item {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n.container .filters .init3 {\n  animation: init 0.5s 0.6s both;\n}\n\n.container .options {\n  animation: toright 0.5s 1s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .options p {\n  margin: 0 0 0 10px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media print {\n  @page {\n    size: landscape;\n    margin: 0;\n  }\n\n  .container .filters {\n    display: none;\n  }\n\n  .container .options {\n    display: none;\n  }\n\n  .container .header {\n    display: none;\n  }\n\n  .container .data .tableContainer {\n    box-shadow: none;\n  }\n\n  .container .data .tableContainer .tableHeader {\n    color: black !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PremiosPagados_container__W8fZx`,
	"header": `PremiosPagados_header__HRsGY`,
	"titleContainer": `PremiosPagados_titleContainer__TZioN`,
	"toright": `PremiosPagados_toright__3KOEt`,
	"arrow": `PremiosPagados_arrow__kFDfo`,
	"loader": `PremiosPagados_loader__xy65r`,
	"data": `PremiosPagados_data__tG4Zy`,
	"tableContainer": `PremiosPagados_tableContainer__sNFpH`,
	"toleft": `PremiosPagados_toleft__+zerq`,
	"tableHeader": `PremiosPagados_tableHeader__chNEv`,
	"filters": `PremiosPagados_filters__2mWNW`,
	"item": `PremiosPagados_item__Z7zdx`,
	"init": `PremiosPagados_init__adpCK`,
	"init1": `PremiosPagados_init1__8j0Uo`,
	"init2": `PremiosPagados_init2__Hi5Lg`,
	"init3": `PremiosPagados_init3__nhitH`,
	"options": `PremiosPagados_options__0Y2Jr`
};
export default ___CSS_LOADER_EXPORT___;
